import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import style from './PageWrapper.module.scss';

const cx = classNames.bind(style);

const PageWrapper = ({ children, className, style, dataTestId }) => {
  return (
    <div
      data-testid={dataTestId}
      className={cx('pagewrapper', className, dataTestId)}
      style={style}
    >
      <div
        className={cx('pagewrapper__content', dataTestId)}
        data-testid={`${dataTestId}-wrapper`}
      >
        {children}
      </div>
    </div>
  );
};

PageWrapper.propTypes = {
  dataTestId: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

PageWrapper.defaultProps = {
  dataTestId: '',
  children: null,
  className: '',
  style: {},
};

export default PageWrapper;
